import React from "react";
import StudyItem from "./StudyItem";
import AboutData from "../../../data/about.json";
import "./education.scss";

// Book/Education Icon SVG
const BookIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        <path d="M12 6v7" />
        <path d="M8 9h8" />
    </svg>
);

const AboutAward = () => {
    const educationData = AboutData.find((item) => item.id === "Education");

    return (
        <section className="section education-section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-8">
                        {/* Section Header */}
                        <div className="education-header">
                            <div className="education-header__icon">
                                <BookIcon />
                            </div>
                            <div className="education-header__content">
                                <span className="education-header__subtitle">
                                    My Journey
                                </span>
                                <h2 className="education-header__title">
                                    {educationData?.title ||
                                        "Educational Background"}
                                </h2>
                            </div>
                        </div>

                        {/* Education Timeline */}
                        <div className="education-timeline">
                            {educationData?.educationItem?.map(
                                (item, index) => (
                                    <StudyItem
                                        key={item.id}
                                        data={item}
                                        index={index}
                                    />
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutAward;
